import React from 'react'
import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import App from './App.jsx'
import './styles.css'

Sentry.init({
  dsn: 'https://a61f1805a3bcbe9b31195efd4003be60@o4510987694309376.ingest.us.sentry.io/4511013820366848',
  environment: import.meta.env.MODE,
  sendDefaultPii: true,
  tracesSampleRate: 0,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,
  denyUrls: [
    // Browser extensions and other injected scripts
    /extensions\//i,
    /^chrome:\/\//i,
    /^chrome-extension:\/\//i,
    /^moz-extension:\/\//i,
    // Known malicious/tracking domains
    /sevendata\.fun/i,
  ],
  beforeSend(event) {
    // Drop errors from third-party scripts not in our app
    const frames = event.exception?.values?.[0]?.stacktrace?.frames || [];
    const hasAppFrame = frames.some((f) => f.in_app);
    if (frames.length > 0 && !hasAppFrame) return null;
    return event;
  },
})

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
